import axios from "axios";

let onUnauthorized = null;
let redirecting = false;

export const setOnUnauthorized = (handler) => {
  onUnauthorized = handler;
};

// Triggers a single login redirect even when many concurrent requests 401 at once
export const redirectToLogin = () => {
  if (redirecting || !onUnauthorized) return;
  redirecting = true;
  onUnauthorized();
};

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      redirectToLogin();
    }
    return Promise.reject(error);
  },
);

const auth = (token) => {
  axios.defaults.baseURL = process.env.REACT_APP_SERVER_URL;
  axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

  return axios;
};

const ai = {
  auth,
};

export default ai;
